'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.daysFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/daysFromNow.js
// module id = 259
// module chunks = 0